import React from "react";
import "./DeleteAccount.css";

const DeleteAccount = () => {
  return (
    <div className="delete-account-container">
      <div className="delete-account-card">
        <h2 className="delete-account-title">DELETE ACCOUNT</h2>
        <p className="delete-account-text">
          If you want to delete your account, please send us an email at:<br />
          <strong>
            <a 
              href="mailto:ybetechltd@gmail.com" 
              className="delete-account-email"
              aria-label="Send email to delete account"
            >
              ybetechltd@gmail.com
            </a>
          </strong>
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;